import { z } from "zod";

export const allocationAccountSchema = z.object({
  warehouse_name: z
    .string({ message: "Allocation Account Name is required" })
    .nonempty({ message: "Allocation Account Name is required" }),

  // main_warehouse_name: z
  //   .string({ message: "Main Allocation Account Name is required" })
  //   .nonempty({ message: "Main Allocation Account Name is required" }),

  warehouse_phone1: z
    .string({ message: "Phone Number is required" })
    .nonempty({ message: "Phone Number is required" })
    .regex(/^[0-9]+$/, { message: "Phone Number must contain only digits." })
    .max(11, { message: "Phone Number must not exceed 11 digits" }),

  warehouse_phone2: z
    .string()
    .regex(/^[0-9]*$/, { message: "Phone Number must contain only digits." })
    .max(11, { message: "Phone Number must not exceed 11 digits" })
    .nullable()
    .optional(),

  warehouse_phone3: z
    .string()
    .regex(/^[0-9]*$/, { message: "Phone Number must contain only digits." })
    .max(11, { message: "Phone Number must not exceed 11 digits" })
    .nullable()
    .optional(),

 warehouse_email: z.string().nullable().optional(),
main_warehouse_id: z.string({ message: "Main Warehouse Name is required" }).or(z.number()).refine(
  (val) => val !== "" && val !== null && val !== undefined,
  { message: "Main Warehouse Name is required" }
),

  contact_first_name: z.string().nullable().optional(),
  contact_phoneno: z.string().nullable().optional(),
  description: z.string().nullable().optional(),
});

export type ZAllocationAccount = z.infer<typeof allocationAccountSchema>;

//@ts-ignore
export interface TAllocationAccount extends ZAllocationAccount {
  warehouse_id: string | number;
  warehouse_city_name: string;
  // main_warehouse_id: string | number; // aligned with schema
  main_warehouse_name?: string;
  warehouse_division_name: string;
  warehouse_state_name: string;
  warehouse_township_name: string;
  warehouse_country_name: string;
}
